import { action, makeObservable, observable } from 'mobx';

export class GoogleAnalyticsManager {
  constructor() {
    makeObservable(this);
  }

  @observable googleAnalyticsId = '';

  @action setGoogleAnalyticsId = (id) => {
    this.googleAnalyticsId = id;
  }

  @action clearAll = () => {
    this.googleAnalyticsId = '';
  }
}

export default new GoogleAnalyticsManager();
